import React from 'react';
import $ from 'jquery';

import BaseClass from '@/pages/BaseClass';

import {authUrl, httpPost, message, ngUrl,} from '@/utils/tools';

export default class App extends BaseClass {
    constructor(props) {
        super(props);

        this.state = {
            'info': {
                'mobile': '',
                'smsVeriCode': '',
                'password': '',
                'password1': '',
            },
            'timer': 0,
        };
    }

    componentDidMount() {
    }

    sendValidateCode() {
        if (this.state.timer) return false;
        let mobile = this.state.info.mobile;
        if (!mobile) {
            message('请输入手机号');
            $('[name="mobile"]').trigger('focus');
            return false;
        }

        let preg = /^1\d\d\d{8}$/;
        if (!mobile.match(preg)) {
            message('请输入正确的手机号');
            $('[name="mobile"]').trigger('focus');
            return false;
        }

        let url = authUrl('/resetPwd/sendVeriCode');
        let param = {mobile};
        httpPost(url, param)
            .then(() => {
                this.setState({
                    'timer': 20,
                });
                let loop = window.setInterval(() => {
                    let timer = this.state.timer;
                    this.setState({
                        'timer': --timer,
                    });

                    if (timer == 0) {
                        window.clearInterval(loop);
                        return false;
                    }
                }, 1000);
            });
    }

    submit() {
        let url = authUrl('/resetPwd');
        let param = JSON.parse(JSON.stringify(this.state.info));
        if (!param.mobile.length) {
            message('请输入手机号');
            $('[name="mobile"]').trigger('focus');
            return false;
        }

        let preg = /^1\d\d\d{8}$/;
        if (!param.mobile.match(preg)) {
            message('请输入正确的手机号');
            $('[name="mobile"]').trigger('focus');
            return false;
        }
        param.username = param.mobile;

        if (!param.smsVeriCode.length) {
            message('请输入短信验证码');
            $('[name="smsVeriCode"]').trigger('focus');
            return false;
        }

        if (!param.password.length) {
            message('请输入密码');
            $('[name="password"]').trigger('focus');
            return false;
        }
        if (param.password != param.password1) {
            message('两次密码输入不一致');
            $('[name="password1"]').trigger('focus');
            return false;
        }

        httpPost(url, param)
            .then(data => {
                message('密码重置成功，您可以继续登录', 'success');
                this.props.history.goBack();
            });
    }

    render() {
        return (
            <div className="body register-page">
                <div className="register-inner">
                    <div className="login-form findpassword-form">
                        <div className="captain">
                            <h3>找回密码</h3>
                        </div>
                        <form onSubmit={e => {
                            e.preventDefault();
                            this.submit()
                        }}>
                            <div className="form-body">
                                <div className="form-row">
										<span className="label">
											手机号
										</span>
                                    <input name="mobile" value={this.state.info.mobile}
                                           onChange={e => this.bindModel(e)} className="input-text"/>
                                    <div className="clear"></div>
                                </div>
                                <div className="form-row">
										<span className="label">
											短信验证码
										</span>
                                    <span className="input-wrapper spec">
											<input name="smsVeriCode" value={this.state.info.smsVeriCode}
                                                   onChange={e => this.bindModel(e)} className="input-text"/>
											<span className="after-node">
												{this.state.timer == 0 ? (
                                                    <button className="button button-border border-blue"
                                                            onClick={() => this.sendValidateCode()}
                                                            type="button">发送验证码</button>
                                                ) : (
                                                    <button className="button button-border border-gray"
                                                            type="button">等待{this.state.timer >= 10 ? this.state.timer : ('0' + this.state.timer)}秒</button>
                                                )}
											</span>
										</span>
                                    <div className="clear"></div>
                                </div>
                                <div className="form-row">
										<span className="label">
											设置新密码
										</span>
                                    <input name="password" type="password" value={this.state.info.password}
                                           onChange={e => this.bindModel(e)} className="input-text"/>
                                    <div className="clear"></div>
                                </div>
                                <div className="form-row">
										<span className="label">
											确认密码
										</span>
                                    <input name="password1" type="password" value={this.state.info.password1}
                                           onChange={e => this.bindModel(e)} className="input-text"/>
                                    <div className="clear"></div>
                                </div>
                                <div style={{'height': '10px'}}></div>
                                <div className="form-row text-center" style={{'margin': '1em 0 2em 0'}}>
                                    <button className="button submit-button button-blue">完成</button>
                                </div>
                                <div className="text-left">
                                    <a href={ngUrl('login')} className="text-blue">&lt;&lt;&nbsp;返回登录</a>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div className="height-30"></div>
                </div>
            </div>
        );
    }
}


